import { render, staticRenderFns } from "./VPricer.vue?vue&type=template&id=5c8b9127&"
import script from "./VPricer.vue?vue&type=script&lang=js&"
export * from "./VPricer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports